import React, { useState } from 'react';

export const LocaleContext = React.createContext();

export function LocaleProvider(props) {
  const [locale, setLocale] = useState('tr');
  const value = React.useMemo(() => [locale, setLocale], [locale]);
  return <LocaleContext.Provider value={value} {...props} />;
}
